module.exports = __webpack_public_path__ + "301e0a59e4c56ce5866ecbad907e3702.jpg";